export default class FactCtrl {
  constructor(Fact, currentFact, $uibModalInstance) {
    this.modal = $uibModalInstance
    this.fact = currentFact || {}
    this.model = Fact;
    this.editFact = this.editFact.bind(this)
  }

  editFact(data) {
    var p = new this.model(data).api.update()
    p.then(this.modal.close)
    return p
  }
}
FactCtrl.$inject = ['Fact', 'currentFact', '$uibModalInstance'];



// WEBPACK FOOTER //
// ./project/modals/fact/fact.controller.js